import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default () => {
    const { response: { query }} = useAppState()

    useEffect(() => {
        window.nostojs((api) => {
            api.loadRecommendations();
        });
    }, [])

    return (
        <div>
            <div class="ns-noresults-container">
                <p class="ns-noresults-text">No results found for "{query}"</p>
            </div>
            <div class="nosto_element" id="notfound-nosto-3"></div>
        </div>
    )
}
